import { SecureApi } from '../../core/secure.api';
import { Injectable } from '@angular/core';
@Injectable()
export class InformationsService {
    url = 'support-center-infor';
    constructor(public secureApi: SecureApi) {
    }

    all(language) {
        return this.secureApi.get(this.url + '/index/' + language);
    }

    /**
     * @param videoId
     * @param languageCode
     * @param {string} clinicId
     * @returns {Observable<any>}
     */
    read(languageCode) {
        if (!languageCode) {
            return;
        }

        return this.secureApi.get(this.url + '/index/' + languageCode);
    }

    /**
     * @param language
     * @param basicForm
     * @returns {Observable<any>}
     */
    save(language, basicForm) {
        let url = this.url + '/update/';
        if (language) {
            url += language;
            return this.secureApi.post(url, basicForm, false);
        }
    }
}
